import type { FileMetadata } from '@/types/poc/helia';
import type {
  FileDeletedMessage,
  FileUploadedMessage,
  FolderCreatedMessage,
  FolderDeletedMessage,
  P2PMessage,
  SixCreatedMessage,
  SixDeletedMessage,
  SixUpdatedMessage,
} from '@/types/poc/message';

interface BaseMessageArgs {
  id?: string;
  sender?: string;
  targetPeerId?: string;
  timestamp?: number;
}

function createBaseMessage({
  id = crypto.randomUUID(),
  sender = '',
  targetPeerId,
  timestamp = Date.now(),
}: BaseMessageArgs): P2PMessage {
  return {
    id,
    sender,
    targetPeerId,
    timestamp,
    type: '',
  };
}

interface CreateFileReadyForDownloadMessageArgs {
  id?: string;
  cid: string;
  metadata: FileMetadata;
  sender?: string;
  targetPeerId?: string;
  timestamp?: number;
}

export function createFileReadyForDownloadMessage({
  id,
  cid,
  metadata,
  sender,
  targetPeerId,
  timestamp = Date.now(),
}: CreateFileReadyForDownloadMessageArgs): FileUploadedMessage {
  return {
    ...createBaseMessage({ id, sender, targetPeerId, timestamp }),
    type: 'file-ready-for-download',
    cid,
    metadata,
  };
}

interface CreateFileDeletedMessageArgs {
  sixId: string;
  fileId: string;
  id?: string;
  sender?: string;
  timestamp?: number;
}

export function createFileDeletedMessage({
  sixId,
  fileId,
  id,
  sender,
  timestamp,
}: CreateFileDeletedMessageArgs): FileDeletedMessage {
  return {
    ...createBaseMessage({ id, sender, timestamp }),
    type: 'file-deleted',
    sixId,
    fileId,
  };
}

interface CreateFolderDeletedMessageArgs {
  sixId: string;
  folderId: string;
  id?: string;
  sender?: string;
  timestamp?: number;
}

export function createFolderDeletedMessage({
  sixId,
  folderId,
  id,
  sender,
  timestamp,
}: CreateFolderDeletedMessageArgs): FolderDeletedMessage {
  return {
    ...createBaseMessage({ id, sender, timestamp }),
    type: 'folder-deleted',
    sixId,
    id: folderId,
  };
}

interface CreateFolderCreatedMessageArgs {
  sixId: string;
  folderName: string;
  folderPath: string;
  id?: string;
  sender?: string;
  timestamp?: number;
}

export function createFolderCreatedMessage({
  sixId,
  folderName,
  folderPath,
  id,
  sender,
  timestamp,
}: CreateFolderCreatedMessageArgs): FolderCreatedMessage {
  return {
    ...createBaseMessage({ id, sender, timestamp }),
    type: 'folder-created',
    sixId,
    folderName,
    folderPath,
  };
}

interface CreateSixCreatedMessageArgs {
  id?: string;
  sender?: string;
  timestamp?: number;
}

export function createSixCreatedMessage({
  id,
  sender,
  timestamp,
}: CreateSixCreatedMessageArgs = {}): SixCreatedMessage {
  return {
    ...createBaseMessage({ id, sender, timestamp }),
    type: 'six-created',
  };
}

interface CreateSixUpdatedMessageArgs {
  id?: string;
  sender?: string;
  timestamp?: number;
}

export function createSixUpdatedMessage({
  id,
  sender,
  timestamp,
}: CreateSixUpdatedMessageArgs = {}): SixUpdatedMessage {
  return {
    ...createBaseMessage({ id, sender, timestamp }),
    type: 'six-updated',
  };
}

interface CreateSixDeletedMessageArgs {
  id?: string;
  sender?: string;
  timestamp?: number;
}

export function createSixDeletedMessage({
  id,
  sender,
  timestamp,
}: CreateSixDeletedMessageArgs = {}): SixDeletedMessage {
  return {
    ...createBaseMessage({ id, sender, timestamp }),
    type: 'six-deleted',
  };
}
